export const SAVE_FIELDS = 'client/SAVE_FIELDS';
export const REHYDRATE = 'persist/REHYDRATE';

const initialState = {};

export const saveFields = fields => ({ type: SAVE_FIELDS, payload: fields });

export const clientReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    // We use redux-persist to save client state in sessionStorage
    // It fires the REHYDRATE action on load
    case REHYDRATE:
      // Note: in this reducer we give state the ability to override payload.
      // This is because REHYDRATE fires after URL params are digested.
      return { ...action.payload.client, ...state };
    case SAVE_FIELDS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
